<div class="relative" *ngIf="method">
    <div class="align-center mb-5 block w-full pr-0 dark:filter-yellow">
        <img
            *ngIf="method.payment_type !== 'S' && method.code !== 'sveapay'"
            src="assets/pm_{{ method?.code }}.png"
            alt="" />
        <mat-icon *ngIf="method.payment_type === 'S' && method.code === 'sveapay'">account_balance</mat-icon>
    </div>

    <div class="box-border px-4 py-0">
        <div class="bold mb-1 inline-block" *ngIf="showTitle">
            <span>{{ method | translateObjectField: 'descr' : lang }}</span>
        </div>
        <div>
            <span>{{ 'PAYMENT_METHOD_DESCRIPTION' | translate }}</span>
        </div>
    </div>
</div>
